export function createProductId({
  periodName,
  periodQuantity,
  price,
}: {
  periodName: string
  periodQuantity: number | null
  price: number
}): string {
  return `famio_${periodQuantity}_${periodName}_${price}`
}
